import { iappApiV1 } from '~/shared/services/api';

import { HomeContentItem, HomeFAQItem } from '../types';

async function getHomeContent(): Promise<HomeContentItem[]> {
  const url = 'reference/home-content';
  const response = await iappApiV1.get<HomeContentItem[]>(url);

  return response.data;
}

async function getHomeFAQ(): Promise<HomeFAQItem[]> {
  const url = 'reference/faqs';
  const response = await iappApiV1.get<HomeFAQItem[]>(url);
  return response.data;
}

export { getHomeContent, getHomeFAQ };
